var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header__logo"},[_c('img',{attrs:{"src":"https://i.imgur.com/3ByC2Jc_d.webp?maxwidth=760&fidelity=grand","alt":""}})]),_c('span',{staticClass:"header__title"})])
}]

export { render, staticRenderFns }